"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminMocks = void 0;

var _msw = require("msw");

var getAdminsMock = _msw.rest.get('/api/v1/organization/admins', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      id: 1,
      firstName: 'User Mock1',
      lastName: 'Last Name1'
    }, {
      id: 2,
      firstName: 'User Mock2',
      lastName: 'Last Name2'
    }]
  }));
});

var adminMocks = [getAdminsMock];
exports.adminMocks = adminMocks;